/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {GetterTree} from 'vuex';
import {RootState} from '@/store/types';
import {UgcItemInterface, UgcItemStateInterface} from '@/store/modules/ugc-item/types';

/**
 * The UGC item module getters provide entry points for stored data.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const getters: GetterTree<UgcItemStateInterface, RootState> = {
    /**
     * Determines if an item has been selected.
     *
     * @param {UgcItemStateInterface} state
     *
     * @returns {boolean}
     */
    hasSelectedItem(state: UgcItemStateInterface): boolean {
        return (undefined !== state.selectedId && '' !== state.selectedId);
    },

    /**
     * Get the items from the state.
     *
     * @param {UgcItemStateInterface} state
     *
     * @returns {UgcItemInterface[]}
     */
    items(state: UgcItemStateInterface): UgcItemInterface[] {
        return state.items;
    },

    /**
     * Check that the state has items.
     *
     * @param {UgcItemStateInterface} state
     *
     * @returns {boolean}
     */
    hasItems(state: UgcItemStateInterface): boolean {
        return state.items && state.items.length > 0;
    },


};
